"use strict";
/*
 * Created on 15. 1. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var DateUtils_1 = require("../../core/utils/DateUtils");

var ObjectUtils_1 = require("../../core/utils/ObjectUtils");

var ExportedPriceListRowState_1 = require("./ExportedPriceListRowState");

var PriceListRowChange_1 = require("./PriceListRowChange"); //tslint:disable:max-classes-per-file

/**
 * <p>Represents unique key of exported price list row (or preparing price list row for export).</p>
 *
 * <p>Should be used as key of immutable structures (map, set) used within batch processing of export process.</p>
 *
 * Preparation for memory optimizations.
 */


var ExportedPriceListRowKey =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ExportedPriceListRowKey, _DomainObject_1$Domai);

  /**
   * @param priceListExternalId external id of price list header
   * @param dateFrom price validity from
   * @param productExternalId external id of products
   */
  function ExportedPriceListRowKey(priceListExternalId, dateFrom, productExternalId) {
    var _this;

    _classCallCheck(this, ExportedPriceListRowKey);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExportedPriceListRowKey).call(this));
    _this.priceListExternalId = priceListExternalId;
    _this.dateFrom = dateFrom;
    _this.productExternalId = productExternalId;
    return _this;
  }

  _createClass(ExportedPriceListRowKey, [{
    key: "equals",
    value: function equals(other) {
      if (other instanceof ExportedPriceListRowKey) {
        var otherKey = other;
        return this.priceListExternalId === otherKey.priceListExternalId && this.dateFrom.valueOf() === otherKey.dateFrom.valueOf() && this.productExternalId.valueOf() === otherKey.productExternalId.valueOf();
      } else {
        return false;
      }
    }
  }, {
    key: "hashCode",
    value: function hashCode() {
      return ObjectUtils_1.ObjectUtils.hashCode("".concat(this.priceListExternalId.valueOf(), "_").concat(this.dateFrom.valueOf(), "_").concat(this.productExternalId));
    }
  }]);

  return ExportedPriceListRowKey;
}(DomainObject_1.DomainObject);

exports.ExportedPriceListRowKey = ExportedPriceListRowKey;
/**
 * Price list row represents single exported price in {@link PriceList price list}.
 *
 * @author Radek Beran
 */

var ExportedPriceListRow =
/*#__PURE__*/
function (_DomainObject_1$Domai2) {
  _inherits(ExportedPriceListRow, _DomainObject_1$Domai2);

  /**
   * Constructs exported price list row.
   * @param id
   * @param changeType
   * @param changeReason reason of price change (additional info)
   * @param priceListExternalId
   * @param priceListInternalId
   * @param dateFrom
   * @param dateTo
   * @param productExternalId includes both productId and salesVariantId parts, but exported product_id will contain only productId part
   * @param productInternalId
   * @param priceListPriority priority number of price list
   * @param productName name of product
   * @param salesVariantId
   * @param price
   * @param vatTypeId
   * @param externalPriceCode
   * @param sequenceId
   * @param releaseId id of related {@link Release}
   * @param exportedReleaseId id of related {@link ExportedRelease} (export run within a release;
   * sellout release can be exported more times)
   * @param releaseItemId id of related {@link ReleaseItem} or {@link SelloutReleaseItem} whose export created this price list row change
   * @param priceZoneId id of price zone; filled if this price list row change was created by an exported regular {@link ReleaseItem}
   * that has prices scoped for individual price zones
   * @param siteId id of site (in case of sellout release or regular site release)
   * @param siteName name/address of site (in case of sellout release or regular site release)
   * @param state
   * @param exported
   * @param accepted
   * @param oldPrice old conflicting price that this change has replaced (if any); It is another ExportedPriceListRow from a previous
   * release (or the same in case of reopening). It is found by price list row imported from IDB. If there is no corresponding exported
   * row, it is null.
   * @param newPrice new price that initiated this change; Filled only in case there is an older price to replace. Null for price
   * termination.
   */
  function ExportedPriceListRow(id, changeType, changeReason, priceListExternalId, priceListInternalId, priceListPriority, dateFrom, dateTo, productExternalId, productInternalId, productName, salesVariantId, price, vatTypeId, externalPriceCode, sequenceId, releaseId, exportedReleaseId, releaseItemId, priceZoneId, siteId, siteName, state, exported, accepted, oldPrice, newPrice) {
    var _this2;

    _classCallCheck(this, ExportedPriceListRow);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(ExportedPriceListRow).call(this));
    _this2.id = id;
    _this2.changeType = changeType;
    _this2.changeReason = changeReason;
    _this2.priceListExternalId = priceListExternalId;
    _this2.priceListInternalId = priceListInternalId;
    _this2.priceListPriority = priceListPriority;
    _this2.dateFrom = dateFrom;
    _this2.dateTo = dateTo;
    _this2.productExternalId = productExternalId;
    _this2.productInternalId = productInternalId;
    _this2.productName = productName;
    _this2.salesVariantId = salesVariantId;
    _this2.price = price;
    _this2.vatTypeId = vatTypeId;
    _this2.externalPriceCode = externalPriceCode;
    _this2.sequenceId = sequenceId;
    _this2.releaseId = releaseId;
    _this2.exportedReleaseId = exportedReleaseId;
    _this2.releaseItemId = releaseItemId;
    _this2.priceZoneId = priceZoneId;
    _this2.siteId = siteId;
    _this2.siteName = siteName;
    _this2.state = state;
    _this2.exported = exported;
    _this2.accepted = accepted;
    _this2.oldPrice = oldPrice;
    _this2.newPrice = newPrice;
    return _this2;
  }

  _createClass(ExportedPriceListRow, [{
    key: "equalsInPrice",
    value: function equalsInPrice(other) {
      return (this.changeType === other.changeType || ExportedPriceListRow.INSERT_UPDATE_SET.contains(this.changeType) && ExportedPriceListRow.INSERT_UPDATE_SET.contains(other.changeType)) && this.priceListExternalId === other.priceListExternalId && this.priceListPriority === other.priceListPriority && this.dateFrom.isSame(other.dateFrom) && this.dateTo.isSame(other.dateTo) && this.productExternalId === other.productExternalId && this.salesVariantId === other.salesVariantId && this.price.equals(other.price) && this.vatTypeId === other.vatTypeId && this.externalPriceCode === other.externalPriceCode;
    }
    /**
     * The matching criteria relates to a primary key in a source DB of price rows. Thus, there can be only one {@link PriceRow} with
     * given parameters but possibly multiple {@link ExportedPriceListRow}. The last exported row should correspond to the imported
     * price row.
     */

  }, {
    key: "matchesImportedPriceListRow",
    value: function matchesImportedPriceListRow(price) {
      return this.dateFrom.isSame(price.dateFrom, 'day') && this.productInternalId === price.productId && this.priceListInternalId === price.priceListId;
    }
    /**
     * Corresponds to {@link PriceListRow.getPriceListRowPK}.
     */

  }, {
    key: "getPriceListRowPK",
    value: function getPriceListRowPK() {
      return this.productInternalId + this.priceListInternalId + DateUtils_1.DateUtils.dayAndYear(this.dateFrom);
    }
  }, {
    key: "withValidity",
    value: function withValidity(dateFrom, dateTo) {
      return this.copy('dateFrom', dateFrom).copy('dateTo', dateTo);
    }
  }, {
    key: "withChange",
    value: function withChange(changeType, sequenceId, changeReason) {
      return this.copy('changeType', changeType).copy('sequenceId', sequenceId).copy('changeReason', changeReason);
    }
  }, {
    key: "withOldAndNewPrice",
    value: function withOldAndNewPrice(oldPrice, newPrice) {
      return this.copy('oldPrice', oldPrice).copy('newPrice', newPrice);
    }
  }, {
    key: "withSequenceId",
    value: function withSequenceId(sequenceId) {
      return this.copy('sequenceId', sequenceId);
    }
    /**
     * <p>Returns an ID of the the first release to export this price before all subsequent updates from other releases. It corresponds
     * to {@link this.releaseId} or {@link ExportedPriceListRow.releaseId release ID} of the last {@link ExportedPriceListRow.oldPrice}
     * in chain - oldPrice.oldPrice.oldPrice...</p>
     */

  }, {
    key: "getOriginalReleaseId",
    value: function getOriginalReleaseId() {
      return this.getOriginalReleaseIdRecur(this);
    }
  }, {
    key: "getOriginalReleaseIdRecur",
    value: function getOriginalReleaseIdRecur(exportedRow) {
      if (!exportedRow.oldPrice || exportedRow.isNewPriceInsertion()) {
        return exportedRow.releaseId;
      }

      return this.getOriginalReleaseIdRecur(exportedRow.oldPrice);
    }
    /**
     * <p>Returns an ID of the the first release item to export this price before all subsequent updates from other releases. It corresponds
     * to {@link this.releaseItemId} or {@link ExportedPriceListRow.releaseItemId release item ID} of the last
     * {@link ExportedPriceListRow.oldPrice} in chain - oldPrice.oldPrice.oldPrice...</p>
     */

  }, {
    key: "getOriginalReleaseItemId",
    value: function getOriginalReleaseItemId() {
      return this.getOriginalReleaseItemIdRecur(this);
    }
  }, {
    key: "getOriginalReleaseItemIdRecur",
    value: function getOriginalReleaseItemIdRecur(exportedRow) {
      if (!exportedRow.oldPrice || exportedRow.isNewPriceInsertion()) {
        return exportedRow.releaseItemId;
      }

      return this.getOriginalReleaseItemIdRecur(exportedRow.oldPrice);
    }
    /**
     * <p>If this is a {@link PriceListRowChange.Update} and a new price validity starts at the same time as an old price from another
     * release, the change affects two release items and must be handled specifically.</p>
     */

  }, {
    key: "replacesAnotherReleasePrice",
    value: function replacesAnotherReleasePrice() {
      return this.changeType === PriceListRowChange_1.PriceListRowChange.Update && this.oldPrice !== null && this.newPrice !== null && this.oldPrice.dateFrom.isSame(this.newPrice.dateFrom) && this.newPrice.getOriginalReleaseId() !== this.oldPrice.getOriginalReleaseId();
    }
    /**
     * <p>If this is a {@link PriceListRowChange.Update} and a new price validity starts at the same time as an old price from the same
     * release, returns true.</p>
     */

  }, {
    key: "replacesSameReleasePrice",
    value: function replacesSameReleasePrice() {
      return this.changeType === PriceListRowChange_1.PriceListRowChange.Update && this.oldPrice !== null && this.newPrice !== null && this.oldPrice.dateFrom.isSame(this.newPrice.dateFrom) && this.newPrice.getOriginalReleaseId() === this.oldPrice.getOriginalReleaseId();
    }
    /**
     * <p>If this does not modify another price, it is considered a new price insertion.</p>
     * <p>If this is an {@link PriceListRowChange.Update} and a new price validity starts at the same time as an old price, it is a special
     * case of a new price insertion. It can be an update of a price from the same reopened release or it can replace a price from another
     * one.</p>
     */

  }, {
    key: "isNewPriceInsertion",
    value: function isNewPriceInsertion() {
      return this.oldPrice === null || this.changeType === PriceListRowChange_1.PriceListRowChange.Update && this.newPrice !== null && this.oldPrice.dateFrom.isSame(this.newPrice.dateFrom);
    }
  }, {
    key: "toString",
    value: function toString() {
      return "id=".concat(this.id, ", changeType=").concat(this.changeType, ", dateFrom=").concat(this.dateFrom, ", dateTo=").concat(this.dateTo, ", priceListExternalId=").concat(this.priceListExternalId, ", priceListInternalId=").concat(this.priceListInternalId, ", productExternalId=").concat(this.productExternalId, ", productInternalId=").concat(this.productInternalId, ", priceListPriority=").concat(this.priceListPriority, ", releaseItemId=").concat(this.releaseItemId, ", priceZoneId=").concat(this.priceZoneId, ", ") + "siteId=".concat(this.siteId, ", sequenceId=").concat(this.sequenceId, ", price=").concat(this.price);
    }
  }], [{
    key: "fromMat",
    value: function fromMat(mat) {
      return new ExportedPriceListRow(mat.id, mat.changeType, mat.changeReason, mat.priceListExternalId, mat.priceListInternalId, mat.priceListPriority, mat.dateFrom, mat.dateTo, mat.productExternalId, mat.productInternalId, mat.productName, mat.salesVariantId, mat.price, mat.vatTypeId, mat.externalPriceCode, mat.sequenceId, mat.releaseId, mat.exportedReleaseId, mat.releaseItemId, mat.priceZoneId, mat.siteId, mat.siteName, mat.state, mat.exported, mat.accepted, mat.oldPrice, mat.newPrice);
    }
  }]);

  return ExportedPriceListRow;
}(DomainObject_1.DomainObject);

exports.ExportedPriceListRow = ExportedPriceListRow;
ExportedPriceListRow.INSERT_UPDATE_SET = immutable_1.Set.of(PriceListRowChange_1.PriceListRowChange.Insert, PriceListRowChange_1.PriceListRowChange.Update);
ExportedPriceListRow.EMPTY_LIST = immutable_1.List();

ExportedPriceListRow.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ExportedPriceListRow.name);
  return {
    id: builder.id('id'),
    changeType: builder.senum('changeType', PriceListRowChange_1.PriceListRowChange, 'seq'),
    changeReason: builder.opt(builder.str('changeReason')),
    priceListExternalId: builder.num('priceListExternalId'),
    priceListInternalId: builder.id('priceListInternalId'),
    priceListPriority: builder.num('priceListPriority'),
    dateFrom: builder.date('dateFrom', DateParser_1.DateParser.ISO_PATTERN),
    dateTo: builder.date('dateTo', DateParser_1.DateParser.ISO_PATTERN),
    productExternalId: builder.str('productExternalId'),
    productInternalId: builder.id('productInternalId'),
    productName: builder.str('productName'),
    salesVariantId: builder.num('salesVariantId'),
    price: builder.bigNum('price'),
    vatTypeId: builder.opt(builder.num('vatTypeId')),
    externalPriceCode: builder.opt(builder.num('externalPriceCode')),
    sequenceId: builder.opt(builder.num('sequenceId')),
    releaseId: builder.id('releaseId'),
    exportedReleaseId: builder.id('exportedReleaseId'),
    releaseItemId: builder.id('releaseItemId'),
    priceZoneId: builder.opt(builder.id('priceZoneId')),
    siteId: builder.opt(builder.id('siteId')),
    siteName: builder.opt(builder.str('siteName')),
    state: builder.senum('state', ExportedPriceListRowState_1.ExportedPriceListRowState, 'seq'),
    exported: builder.date('exported', DateParser_1.DateParser.ISO_PATTERN),
    accepted: builder.opt(builder.date('accepted', DateParser_1.DateParser.ISO_PATTERN)),
    oldPrice: builder.opt(builder.obj('oldPrice', ExportedPriceListRow.schema, function (mat) {
      return ExportedPriceListRow.fromMat(mat);
    })),
    newPrice: builder.opt(builder.obj('newPrice', ExportedPriceListRow.schema, function (mat) {
      return ExportedPriceListRow.fromMat(mat);
    }))
  };
}();